"use strict";

import "../scss/style.scss";

// import IntersectionObserverScroll from "./IntersectionObserver.js";
// import MicroModalWindow from "./MicroModalWindow.js";
// import SplideFlowSlider from "./SplideFlowSlider.js";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    // new IntersectionObserverScroll(".js-inview", "js-inview-acv");
    // new MicroModalWindow();
    // new SplideFlowSlider("#xxxx");
  },
  false,
);
